const styles = {
    screen: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        backgroundColor: '#f5f5f5',
    },
    container: {
        marginTop: '-40px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '40px',
        backgroundColor: '#fff',
        padding: '80px 40px',
        borderRadius: '15px',
        boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.75)',
    },
}

export default styles;
